module.exports = __webpack_public_path__ + "img/finances-block-icon-four.9b634e36.svg";